var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"color":"green lighten-2","icon":"assignment"}},[(!_vm.editNote)?_c('note',{attrs:{"note":_vm.note},on:{"editCard":_vm.noteEdit}}):_c('note-edit',{attrs:{"note":_vm.note},on:{"editCard":_vm.noteEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }